import { useEffect, useRef, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext, API } from '@/App';
import axios from 'axios';

const GoogleCallback = () => {
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace('#', '?')).get('session_id');

    if (!sessionId) {
      navigate('/auth');
      return;
    }

    const exchangeSession = async () => {
      try {
        const response = await axios.post(`${API}/auth/google`, { session_id: sessionId });
        login(response.data.token, response.data.user);

        if (response.data.is_new) {
          navigate('/profile', { state: { completeProfile: true } });
        } else {
          navigate('/home');
        }
      } catch (error) {
        console.error('Google auth failed:', error);
        navigate('/auth');
      }
    };

    exchangeSession();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-900">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-purple-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-white text-lg">Signing in with Google...</p>
      </div>
    </div>
  );
};

export default GoogleCallback;
